<template>
  <div id="wrapper">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data () {
      return {
        fromPath: '/',
        loggedIn: false,
        breadcrumbs: [],
        minimumMinutes: 60,
        maximumDays: 5,
        pageTitle: 'My Carshare',
        companyName: 'TechCar',
        companyEmail: '',
        companyLogo: null,
        companyPhone: '',
        homePage: '',
        theme: '',
        name: '',
        stylesheet: false,
        oneWayTrips: false,
        muaUrl: ''
      }
    },
    created () {
      let organizationName = window.location.hostname
      this.$http.get('public/config', { organizationName }).then((response, status, request) => {
        let body = response.json()
        this.name = body.name
        this.pageTitle = body.pageTitle
        this.theme = body.theme
        this.companyName = body.companyName
        this.companyLogo = body.OrganizationLogo.objectKey
        this.companyPhone = body.companyPhone
        this.companyEmail = body.companyEmail
        this.homePage = body.homePage
        this.minimumMinutes = body.minimumBooking * 60.00
        this.maximumDays = body.maximumBooking
        this.oneWayTrips = body.oneWayTrips
        this.stylesheet = body.stylesheet
        this.muaUrl = body.muaUrl
        document.title = this.pageTitle
        if (this.stylesheet) {
          let style = document.createElement('link')
          style.rel = 'stylesheet'
          style.href = '/css/' + this.stylesheet.replace('scss', 'css')
          let head = document.head || document.getElementsByTagName('head')[0]
          head.appendChild(style)
        }
        $('body').addClass(`skin-${this.theme}`)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?26ae870a